module.exports = __webpack_public_path__ + "static/media/BannerWithoutImage@3x.9e39d0fa3b42b32410fa3eb4a6f6dcda.jpg";